const CATEGORIES = ['unknown', 'connectivity', 'battery', 'device'];
const COLOR_MAP = {
  unknown: '#e5e5e5',
  connectivity: '#00a9e1',
  battery: '#ff7f0e',
  device: '#ffbb78'
};
export default {
  name: 'CoreVirtualDeviceSmartGroupsChartsAlarmLogsByCategory',
  props: {
    alarmLogs: {
      type: Array,
      required: true
    }
  },
  data: function () {
    return {
      categoryColorMap: COLOR_MAP
    };
  },
  computed: {
    legendCount() {
      if (this.alarmLogs.length > 0) {
        return this.datasets[0].data;
      }
      return Array(CATEGORIES.length).fill(0);
    },
    options() {
      const hasLogs = this.alarmLogs.length > 0;
      const totalLogCount = this.datasets[0].data.reduce((acc, count) => acc + count, 0);
      return {
        plugins: {
          datalabels: {
            display: hasLogs,
            backgroundColor: '#f5f5f5',
            borderRadius: 3,
            font: {
              weight: 'bold'
            },
            // hide when labels are shown but value is 0
            formatter: v => v === 0 ? null : v
          },
          doughnutlabel: {
            labels: [{
              text: hasLogs ? totalLogCount : 0,
              font: {
                size: 36,
                weight: 'bold'
              }
            }, {
              text: 'Total',
              font: {
                size: 14
              }
            }]
          }
        },
        tooltips: {
          enabled: false
        },
        cutoutPercentage: 60,
        legend: {
          display: false
        }
      };
    },
    alarmLogsCountsByCategory() {
      const logCategories = this.alarmLogs.reduce((acc, log) => {
        const category = log.logCategory || 'unknown';
        if (!acc[category]) {
          acc[category] = 0;
        }
        acc[category] += 1;
        return acc;
      }, {});
      if (Object.keys(logCategories).length === 0) {
        // If there are no logs, use undefined category to draw grey circle
        // tooltips will be turned off in this case
        logCategories.unknown = -1;
      }
      return logCategories;
    },
    labels() {
      return CATEGORIES.map(category => this.$i18n_t(`AlarmLogs.categories.${category}`));
    },
    datasets() {
      return [{
        backgroundColor: CATEGORIES.map(category => this.categoryColorMap[category] || 'black'),
        data: CATEGORIES.map(category => this.alarmLogsCountsByCategory[category] || 0)
      }];
    }
  }
};